import * as React from 'react'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import { Formik, Form, Field } from 'formik'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
  Typography,
  Alert,
} from '@mui/material'
import { LockReset } from '@mui/icons-material'
import { updateUser } from '../../services'
import { setRequiresPasswordChange } from '../../redux/slices/Auth/login'

const validationSchema = Yup.object({
  nueva_contrasena: Yup.string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .required('La nueva contraseña es requerida'),
  confirmar_contrasena: Yup.string()
    .oneOf([Yup.ref('nueva_contrasena')], 'Las contraseñas no coinciden')
    .required('La confirmación es requerida'),
})

const ForceChangePasswordModal = () => {
  const dispatch = useDispatch()
  const [error, setError] = React.useState(null)

  const handleSubmit = async (values, { setSubmitting }) => {
    setError(null)
    const result = await updateUser({ contrasena: values.nueva_contrasena })
    if (result?.update) {
      dispatch(setRequiresPasswordChange(false))
    } else {
      setError(result?.message || 'No se pudo actualizar la contraseña. Intenta de nuevo.')
    }
    setSubmitting(false)
  }

  return (
    <Dialog
      open
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
        <LockReset color="warning" />
        Debes cambiar tu contraseña
      </DialogTitle>
      <Formik
        initialValues={{ nueva_contrasena: '', confirmar_contrasena: '' }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}>
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <DialogContent sx={{ pt: 1 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Un administrador ha reseteado tu contraseña. Debes crear una nueva antes de
                continuar.
              </Typography>

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              <Field name="nueva_contrasena">
                {({ field }) => (
                  <TextField
                    {...field}
                    label="Nueva contraseña"
                    type="password"
                    fullWidth
                    size="small"
                    sx={{ mb: 2 }}
                    error={touched.nueva_contrasena && Boolean(errors.nueva_contrasena)}
                    helperText={touched.nueva_contrasena && errors.nueva_contrasena}
                  />
                )}
              </Field>

              <Field name="confirmar_contrasena">
                {({ field }) => (
                  <TextField
                    {...field}
                    label="Confirmar contraseña"
                    type="password"
                    fullWidth
                    size="small"
                    error={touched.confirmar_contrasena && Boolean(errors.confirmar_contrasena)}
                    helperText={touched.confirmar_contrasena && errors.confirmar_contrasena}
                  />
                )}
              </Field>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Box sx={{ position: 'relative', width: '100%' }}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={isSubmitting}>
                  Actualizar contraseña
                </Button>
                {isSubmitting && (
                  <CircularProgress
                    size={24}
                    sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-12px', ml: '-12px' }}
                  />
                )}
              </Box>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default ForceChangePasswordModal
